import React, { useContext, useEffect, useState } from "react";
import { Alert, Box, Button, Container, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import BannerSlider from "./slider/BannerSlider";
import RegFooter from "./RegFooter";
import bgImg from "./bg_img.png";
import useTemplateSettings from "../../hooks/useTemplateSettings";
import { useNavigate, useParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import SettingsIcon from "@mui/icons-material/Settings";
import { getErrorResponse } from "../../utils/util";
import { APP_ID } from "../../utils/constants";
const RegTemplates = () => {
  const { id } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const { data, isLoading, isError, error } = useTemplateSettings(id);
  const templateSettings = data?.properties || {};

  const getHeight = () => {
    if (isSmallScreen) return "150px";
    if (isMediumScreen) return "200px";
    if (isLargeScreen) return "300px";
  };
  const getVariant = () => {
    if (isSmallScreen) return "h6";
    if (isMediumScreen) return "h5";
    if (isLargeScreen) return "h4";
  };
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Box
      sx={{
        backgroundColor: "rgb(237, 241, 242)",
        minHeight: "100vh",
        width: "100vw",
        overflow: "auto",
        position: "fixed",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: getHeight(),
          top: 0,
          position: "absolute",
          backgroundImage: `url(${templateSettings.haderBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      ></Box>
      <Box
        sx={{
          width: "100%",
          position: "absolute",
        }}
      >
        <Container maxWidth="md">
          <img
            src={templateSettings.headerBanner}
            alt="Main Header"
            style={{
              marginTop: "18px",
              width: "100%",
              borderRadius: "4px",
              height: "auto",
              marginBottom: "20px",
            }}
          />
          <BannerSlider ADS={templateSettings?.headerSliders ?? []} />
          <Typography
            variant={getVariant()}
            component="h2"
            align="center"
            fontWeight={600}
            my={3}
            sx={{ color: "#E60008" }}
          >
            {data?.formTitle}
          </Typography>
          <Box
            my={2}
            height="192px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              backgroundColor: "primary.light", // Nice background color from MUI theme
              borderRadius: 2, // Slightly rounded corners
              boxShadow: 2, // Adds a subtle shadow
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(`/template-settings/${id}`);
              }}
              startIcon={<SettingsIcon />} // Icon before the text
            >
              Update Template Setting
            </Button>
          </Box>
        </Container>
        <RegFooter templateSettings={templateSettings} />
      </Box>
    </Box>
  );
};

export default RegTemplates;
